// Shared helpers for per-route head metadata (server-rendered, crawler-visible).
export const SITE_ORIGIN = "https://jaikmarketing.com";

type HeadInput = {
  title: string;
  description: string;
  /** Route path beginning with "/" (use "/" for the home page). */
  path: string;
  ogType?: string;
  image?: string;
  noindex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

export function pageHead({ title, description, path, ogType = "website", image = "/og-image.jpg", noindex, jsonLd }: HeadInput) {
  const url = path === "/" ? SITE_ORIGIN : `${SITE_ORIGIN}${path}`;

  const meta: Array<Record<string, string>> = [
    { title },
    { name: "description", content: description },
    { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow" },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: ogType },
    { property: "og:url", content: url },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
  ];

  if (image) {
    const absolute = /^https?:\/\//i.test(image) ? image : `${SITE_ORIGIN}${image.startsWith("/") ? "" : "/"}${image}`;
    meta.push({ property: "og:image", content: absolute });
    meta.push({ name: "twitter:image", content: absolute });
    meta.push({ name: "twitter:card", content: "summary_large_image" });
  }

  const head: {
    meta: Array<Record<string, string>>;
    links: Array<Record<string, string>>;
    scripts?: Array<Record<string, string>>;
  } = {
    meta,
    links: [{ rel: "canonical", href: url }],
  };

  if (jsonLd) {
    head.scripts = [{ type: "application/ld+json", children: JSON.stringify(jsonLd) }];
  }

  return head;
}
